import { OpenGraphMeta } from './OpenGraphMeta'

export class DocumentMetaMap {
  constructor() {
    this.canonical = document.head.querySelector('[rel="canonical"]')
    this.description = document.head.querySelector('[name="description"]')

    this.defaultValues = {
      url: null,
      title: null,
      image: null,
      siteName: null,
      description: null
    }

    this.openGraph = new OpenGraphMeta({
      url: { property: 'url' },
      title: { property: 'title' },
      siteName: { property: 'site_name' },
      description: { property: 'description' },
      type: { property: 'type', content: 'website' },
      image: { property: 'image' },
      imageWidth: { property: 'image:width', content: 1200 },
      imageHeight: { property: 'image:height', content: 630 }
    })
  }

  // set the fallback meta values
  set defaults(defaults) {
    defaults.url = defaults.url || window.location.origin
    Object.keys(this.defaultValues).forEach(prop => {
      if (defaults[prop]) this.defaultValues[prop] = defaults[prop]
    })
  }

  // set meta tag contents with fallback to defaults
  set tags({ title, description, openGraph = {} }) {
    let url = this.defaultValues.url + window.location.pathname
    document.title = title || this.defaultValues.title
    this.canonical.setAttribute('href', url)
    this.description.setAttribute('content', description || this.defaultValues.description)

    openGraph.url = openGraph.url || url
    openGraph.title = openGraph.title || title
    openGraph.description = openGraph.description || description

    // handoff open-graph meta
    this.openGraph.tags = {
      current: openGraph,
      defaults: this.defaultValues
    }
  }
}



// WEBPACK FOOTER //
// ./src/plugins/meta-tags/DocumentMetaMap.js